// ============================================================
// NOWGUT — Data & logika Screening (dipakai bersama oleh
// PublicScreening & Screening)
// ------------------------------------------------------------
// Tiga instrumen: GI (12 soal Ya/Tidak), GSSS (7 soal 0–3),
// FLACC (5 dimensi 0–2).
// Skor maks: GI=12, GSSS=21, FLACC=10.
// Rujukan diverifikasi via pencarian (lihat REFERENCES).
// CATATAN: Tinjau ulang bersama tenaga medis sebelum publikasi.
// ============================================================

// Urutan resmi langkah — SATU sumber kebenaran.
// Mengubah urutan cukup di sini; indikator & navigasi mengikuti.
export const STEPS = ['gi', 'gsss', 'flacc'];

export const STEP_META = {
  gi:    { num: 1, label_id: 'Skrining Awal',     label_en: 'Initial Screening' },
  gsss:  { num: 2, label_id: 'Keparahan Gejala',  label_en: 'Symptom Severity' },
  flacc: { num: 3, label_id: 'Tingkat Nyeri',     label_en: 'Pain Level' },
};

// ---------------------------------------------------------
// GI — Skrining awal (Ya/Tidak), maks 12
// ---------------------------------------------------------
export const GI_QUESTIONS = [
  { id: 'gi_1',  category: 'BAB',         text_id: 'Apakah anak mengalami sembelit (BAB kurang dari 3x seminggu)?', text_en: 'Does the child experience constipation (fewer than 3 bowel movements per week)?' },
  { id: 'gi_2',  category: 'BAB',         text_id: 'Apakah feses (tinja) anak keras atau berbentuk bulat-bulat kecil?', text_en: 'Is the child\u2019s stool hard or in small pellets?' },
  { id: 'gi_3',  category: 'BAB',         text_id: 'Apakah anak pernah mengalami diare (BAB cair lebih dari 3x sehari)?', text_en: 'Has the child experienced diarrhea (watery stool more than 3x a day)?' },
  { id: 'gi_4',  category: 'BAB',         text_id: 'Apakah anak mengejan berlebihan saat BAB?', text_en: 'Does the child strain excessively during bowel movements?' },
  { id: 'gi_5',  category: 'Nyeri',       text_id: 'Apakah anak sering menunjukkan tanda nyeri perut (meringkuk, menangis, memegang perut)?', text_en: 'Does the child often show signs of abdominal pain (curling up, crying, holding stomach)?' },
  { id: 'gi_6',  category: 'Nyeri',       text_id: 'Apakah anak sering kembung atau perutnya terlihat buncit?', text_en: 'Does the child frequently have bloating or a visibly distended abdomen?' },
  { id: 'gi_7',  category: 'Makan',       text_id: 'Apakah anak sering menolak makan atau sangat pemilih makanan?', text_en: 'Does the child frequently refuse food or is very picky?' },
  { id: 'gi_8',  category: 'Makan',       text_id: 'Apakah anak mengonsumsi diet khusus (bebas gluten/kasein)?', text_en: 'Does the child follow a special diet (gluten/casein free)?' },
  { id: 'gi_9',  category: 'Makan',       text_id: 'Apakah asupan serat anak sangat rendah setiap harinya?', text_en: 'Is the child\u2019s daily fiber intake very low?' },
  { id: 'gi_10', category: 'Gejala Lain', text_id: 'Apakah anak sering muntah atau meludah setelah makan?', text_en: 'Does the child frequently vomit or spit up after eating?' },
  { id: 'gi_11', category: 'Gejala Lain', text_id: 'Apakah anak pernah didiagnosis dengan refluks asam (GERD)?', text_en: 'Has the child ever been diagnosed with acid reflux (GERD)?' },
  { id: 'gi_12', category: 'Gejala Lain', text_id: 'Apakah anak menunjukkan perubahan perilaku ketika ada masalah pencernaan?', text_en: 'Does the child show behavioral changes when having digestive problems?' },
];

// ---------------------------------------------------------
// GSSS — Keparahan gejala (0–3), 7 item → maks 21
// ---------------------------------------------------------
export const GSSS_QUESTIONS = [
  { id: 'gsss_1', text_id: 'Muntah kembali / makanan naik lagi (gumoh/ruminasi)', text_en: 'Regurgitation / food coming back up (rumination)' },
  { id: 'gsss_2', text_id: 'Muntah', text_en: 'Vomiting' },
  { id: 'gsss_3', text_id: 'Banyak gas / perut kembung', text_en: 'Excessive gas / bloating' },
  { id: 'gsss_4', text_id: 'Nyeri perut (anak pegang perut/menangis)', text_en: 'Abdominal pain (child holds stomach/cries)' },
  { id: 'gsss_5', text_id: 'Susah BAB (konstipasi)', text_en: 'Difficulty with bowel movements (constipation)' },
  { id: 'gsss_6', text_id: 'Diare (BAB cair/sering)', text_en: 'Diarrhea (watery/frequent stools)' },
  { id: 'gsss_7', text_id: 'BAB di tempat tidak semestinya', text_en: 'Bowel movements in inappropriate places' },
];

export const GSSS_OPTIONS = [
  { value: 0, label_id: 'Tidak ada',  label_en: 'None' },
  { value: 1, label_id: 'Ringan',     label_en: 'Mild' },
  { value: 2, label_id: 'Sedang',     label_en: 'Moderate' },
  { value: 3, label_id: 'Berat',      label_en: 'Severe' },
];

// ---------------------------------------------------------
// FLACC — Nyeri (0–2), 5 dimensi → maks 10
// ---------------------------------------------------------
export const FLACC_CATEGORIES = [
  { id: 'face', label_id: 'F — Wajah', label_en: 'F — Face', options: [
    { value: 0, label_id: 'Tidak ada ekspresi khusus, tersenyum', label_en: 'No particular expression, smiles' },
    { value: 1, label_id: 'Sesekali meringis / menarik diri', label_en: 'Occasional grimace / withdrawal' },
    { value: 2, label_id: 'Sering bergetar dagu, rahang mengatup', label_en: 'Frequent chin trembling, clenched jaw' },
  ]},
  { id: 'legs', label_id: 'L — Kaki', label_en: 'L — Legs', options: [
    { value: 0, label_id: 'Normal, rileks', label_en: 'Normal, relaxed' },
    { value: 1, label_id: 'Gelisah, tegang', label_en: 'Uneasy, tense' },
    { value: 2, label_id: 'Menendang, kaki tertekuk', label_en: 'Kicking, legs drawn up' },
  ]},
  { id: 'activity', label_id: 'A — Aktivitas', label_en: 'A — Activity', options: [
    { value: 0, label_id: 'Berbaring tenang, mudah bergerak', label_en: 'Lying quietly, moves easily' },
    { value: 1, label_id: 'Menggeliat, tidak bisa diam, tegang', label_en: 'Squirming, restless, tense' },
    { value: 2, label_id: 'Kaku atau menghentak', label_en: 'Rigid or jerking' },
  ]},
  { id: 'cry', label_id: 'C — Menangis', label_en: 'C — Cry', options: [
    { value: 0, label_id: 'Tidak menangis', label_en: 'No cry' },
    { value: 1, label_id: 'Merintih, merengek, sesekali mengeluh', label_en: 'Moans, whimpers, occasional complaint' },
    { value: 2, label_id: 'Menangis terus, berteriak', label_en: 'Crying steadily, screaming' },
  ]},
  { id: 'consolability', label_id: 'C — Kenyamanan', label_en: 'C — Consolability', options: [
    { value: 0, label_id: 'Tenang, rileks', label_en: 'Content, relaxed' },
    { value: 1, label_id: 'Tenang dengan sentuhan/pelukan/bujukan', label_en: 'Reassured by touch, hugging, talking' },
    { value: 2, label_id: 'Sulit ditenangkan', label_en: 'Difficult to console' },
  ]},
];

// ---------------------------------------------------------
// Interpretasi skor — mengembalikan level + token warna
// (warna pakai CSS var agar konsisten dengan design system)
// ---------------------------------------------------------
export function getGIInterp(score, isID) {
  if (score <= 3) return { level: isID ? 'Risiko Rendah' : 'Low Risk', tone: 'good' };
  if (score <= 7) return { level: isID ? 'Risiko Sedang' : 'Moderate Risk', tone: 'warn' };
  return { level: isID ? 'Risiko Tinggi' : 'High Risk', tone: 'danger' };
}
export function getGSSSInterp(score, isID) {
  if (score === 0) return { level: isID ? 'Tidak Ada Gejala' : 'No Symptoms', tone: 'good' };
  if (score <= 4)  return { level: isID ? 'Sangat Ringan' : 'Very Mild', tone: 'good' };
  if (score <= 9)  return { level: isID ? 'Ringan' : 'Mild', tone: 'warn' };
  if (score <= 14) return { level: isID ? 'Sedang' : 'Moderate', tone: 'warn' };
  return { level: isID ? 'Berat' : 'Severe', tone: 'danger' };
}
export function getFLACCInterp(score, isID) {
  if (score === 0) return { level: isID ? 'Tidak Ada Nyeri' : 'No Pain', tone: 'good' };
  if (score <= 3)  return { level: isID ? 'Nyeri Ringan' : 'Mild Pain', tone: 'warn' };
  if (score <= 6)  return { level: isID ? 'Nyeri Sedang' : 'Moderate Pain', tone: 'warn' };
  return { level: isID ? 'Nyeri Berat' : 'Severe Pain', tone: 'danger' };
}

// ---------------------------------------------------------
// Rekomendasi tindak lanjut — BERJENJANG EKSKLUSIF
// (memperbaiki bug threshold tumpang tindih: hanya SATU level
// yang muncul, berdasarkan kondisi terberat)
// ---------------------------------------------------------
export function getFollowUp({ giScore, gsssScore, flaccScore }, isID) {
  const high = gsssScore >= 10 || flaccScore >= 7 || giScore >= 8;
  const mid  = gsssScore >= 5  || flaccScore >= 4 || giScore >= 4;

  if (high) return {
    tone: 'danger',
    title: isID ? 'Segera konsultasi' : 'Consult immediately',
    text: isID
      ? 'Skor menunjukkan kemungkinan gangguan pencernaan yang signifikan. Segera temui dokter anak atau spesialis gastroenterologi anak.'
      : 'Scores indicate a possibly significant GI problem. See a pediatrician or pediatric gastroenterologist promptly.',
  };
  if (mid) return {
    tone: 'warn',
    title: isID ? 'Konsultasi dianjurkan' : 'Consultation recommended',
    text: isID
      ? 'Beberapa gejala terdeteksi. Diskusikan hasil ini dengan dokter anak pada kunjungan berikutnya.'
      : 'Some symptoms detected. Discuss these results with your pediatrician at the next visit.',
  };
  return {
    tone: 'good',
    title: isID ? 'Pantau secara berkala' : 'Monitor regularly',
    text: isID
      ? 'Hasil relatif baik. Tetap lakukan pemantauan rutin dan catat perubahan pada catatan harian.'
      : 'Results are relatively good. Keep monitoring regularly and record changes in the daily log.',
  };
}

// ---------------------------------------------------------
// Rujukan ilmiah (terverifikasi via pencarian)
// ---------------------------------------------------------
export const REFERENCES = [
  {
    label_id: 'GSSS — Pengembangan & validasi Gastrointestinal Symptom Severity Scale pada anak & remaja (berbasis kriteria Rome IV)',
    label_en: 'GSSS — Development & validation of the Gastrointestinal Symptom Severity Scale in children & adolescents (Rome IV-based)',
    url: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC11098890/',
  },
  {
    label_id: 'FLACC — Merkel et al. (1997), skala perilaku untuk menilai nyeri pada anak',
    label_en: 'FLACC — Merkel et al. (1997), behavioral scale for scoring pain in young children',
    url: 'https://pubmed.ncbi.nlm.nih.gov/9220806/',
  },
  {
    label_id: 'Buie et al. (2010) — Evaluasi, diagnosis & tata laksana gangguan GI pada individu dengan ASD',
    label_en: 'Buie et al. (2010) — Evaluation, diagnosis & treatment of GI disorders in individuals with ASD',
    url: 'https://publications.aap.org/pediatrics/article/125/Supplement_1/S1/27437',
  },
];